import { type QueryHookOptions, useQuery } from "@apollo/client";
import { CurrentUserQuery } from "../graphql/queries";
import type { CurrentUserQueryType } from "@/types/graphql/partner.generated";

export const useCurrentUserQuery = (options?: QueryHookOptions) => {
  return useQuery<CurrentUserQueryType>(CurrentUserQuery, options);
};
